import { SystemPageKey } from '@internal/page/SystemPageKey';
import { muiClassFixPositionOnModalOpen } from '@internal/utils/constants';
import { TLocale } from '@internal/utils/machine/i18n/TLocale';
import { MachineType } from '@internal/utils/machine/MachineType';
import { useMachineTypeName } from '@internal/utils/machine/useMachineTypeName';
import { urlFor } from '@internal/utils/routing/urls/urlFor';
import classNames from 'classnames';
import React, { useMemo } from 'react';
import { TNavigation } from 'utils/navigation/TNavigation';
import styles from './desktopHeader.module.scss';
import { DesktopNavigationBar } from './DesktopNavigationBar/DesktopNavigationBar';
import { DesktopSearchBar } from './DesktopSearchBar/DesktopSearchBar';

interface Props {
    primaryNavigation: TNavigation;
    secondaryNavigation: TNavigation;
    brandsNavigation: TNavigation;
    locale: TLocale;
    isOnSerp: boolean;
}

export const DesktopHeader: React.FC<Props> = React.memo(props => {
    const { locale, primaryNavigation, secondaryNavigation, brandsNavigation } =
        props;

    const { getMachineTypeName } = useMachineTypeName();
    const allOffersUrl = useMemo(
        () =>
            urlFor(locale, {
                key: SystemPageKey.SearchResults,
                machineTypeName: getMachineTypeName(
                    MachineType.TRACTOR,
                    'plural',
                ),
            }),
        [getMachineTypeName, locale],
    );

    return (
        <header
            className={classNames(
                styles.headerContainer,
                muiClassFixPositionOnModalOpen,
            )}
        >
            <DesktopSearchBar locale={locale} isOnSerp={props.isOnSerp} />
            <DesktopNavigationBar
                locale={locale}
                primaryNavigation={primaryNavigation}
                secondaryNavigation={secondaryNavigation}
                allOffersUrl={allOffersUrl}
                brandsNavigation={brandsNavigation}
            />
        </header>
    );
});

DesktopHeader.displayName = 'DesktopHeader';
